import { call, put, takeLatest } from "redux-saga/effects";
import { getType } from "typesafe-actions";
import { getRolesActions } from "../actions/roles.actions";
import { getRolesApi } from "../api/roles.api";
import { RoleDto } from "../dtos/role.dtos";

function* handleRolesGet() {
	const systemRoles: RoleDto[] = yield call(getRolesApi);
	yield put({ type: getType(getRolesActions.success), payload: systemRoles });
}


export function* watchRolesGetRequest() {
	yield takeLatest(getType(getRolesActions.request), handleRolesGet);
}

export default [watchRolesGetRequest];